import React, { useEffect } from 'react';
import { useFingotiAuth } from '@fingoti/auth-js/react';
import { FingotiLoading } from '@fingoti/components';

export const Logout = () => {
    const { logout } = useFingotiAuth();

    useEffect(() => {
        logout({ returnTo: window.location.origin }).catch((err) => {
            console.error('Logout failed', err);
        });
    }, [logout]);

    return <FingotiLoading fullHeight />;
};
